/**
 * This module provides functions in relation to calling API routes on the backend server and processing the incoming
 * responses. The functions in this module refer to the API endpoint ApiEndPoints.WATERFALL_PAYMENT_PRIORITY_ROW.
 * @module
 */

import {ApiEndPoints, HttpMethods} from "../base/Settings";
import type {
    FetchRequest,
    WaterfallPaymentPriorityRowInput,
    WaterfallPaymentPriorityRow,
    UUID
} from "../base/ui_general/GeneralInterfaces";


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the creation of a new
 * waterfall_payment_priority_row on the server. Only name, description and waterfall_payment_priority_row type need to be specified for this purpose.
 * @param waterfall_payment_priority_rowInput An object of type WaterfallPaymentPriorityRowInput containing the input data for creating the waterfall_payment_priority_row.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_create_waterfall_payment_priority_row(waterfall_payment_priority_rowInput: WaterfallPaymentPriorityRowInput): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_PAYMENT_PRIORITY_ROW,
        method: HttpMethods.POST,
        query_parameters: {},
        body: waterfall_payment_priority_rowInput,
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for updating an existing
 * waterfall_payment_priority_row on the server.
 * @param waterfall_payment_priority_row An object of type WaterfallPaymentPriorityRow containing the updated waterfall_payment_priority_row data.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_update_waterfall_payment_priority_row(waterfall_payment_priority_row: WaterfallPaymentPriorityRow): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_PAYMENT_PRIORITY_ROW,
        method: HttpMethods.PUT,
        query_parameters: {},
        body: waterfall_payment_priority_row,
    };
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for triggering the query of waterfall_payment_priority_rows
 * on the server.
 * @param transaction_id .The UUID of the transaction to query for.
 * @returns A FetchRequest object containing the generated fetch request.*/
export function getRequest_get_all_waterfall_payment_priority_rows(transaction_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_PAYMENT_PRIORITY_ROW,
        method: HttpMethods.GET,
        query_parameters: { transaction_id },
    }
}


/**
 * Creates a FetchRequest object populated with the parameters necessary for deleting an existing
 * waterfall_payment_priority_row on the server.
 * @param waterfall_payment_priority_row_id The UUID of the waterfall_payment_priority_row to delete.
 * @returns A FetchRequest object containing the generated fetch request.
 */
export function getRequest_delete_waterfall_payment_priority_row(waterfall_payment_priority_row_id: UUID): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_PAYMENT_PRIORITY_ROW,
        method: HttpMethods.DELETE,
        query_parameters: { waterfall_payment_priority_row_id: waterfall_payment_priority_row_id },
    };
}
